/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be isolated against other entry modules.
(() => {
//import './dawn';
})();

// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
// extracted by mini-css-extract-plugin

})();

// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
// extracted by mini-css-extract-plugin

})();

// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
// extracted by mini-css-extract-plugin

})();

// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
// extracted by mini-css-extract-plugin

})();

// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
// extracted by mini-css-extract-plugin

})();

/******/ })()
;

var enterKeyCode = 13;
var spaceKeyCode = 32;
var leftKeyCode = 37;
var rightKeyCode = 39;
var downKeyCode = 40;
var upKeyCode = 38;
var escapeCode = 27;
var tabKeyCode = 9;
function escapeMenu(event) {

	var menu_checkbox = document.querySelector("#shop");
	if( event.keyCode == escapeCode ) {
		console.log("escapeMenu");
		// uncheck all selectors in the menu
		document.querySelectorAll("#submenu-shop input[type='checkbox']").forEach(($checkbox) => {
			$checkbox.checked = false;
		});
		menu_checkbox.checked = false;
		if(window.location.hash == "#shop") {
			window.location.hash = "#";
		}
		event.preventDefault();
		document.removeEventListener("keydown",escapeMenu);
		document.querySelector("a.menu-open-by-keyboard").focus();
	} else if( event.keyCode == tabKeyCode ) {
		event.preventDefault();
		var menu_link = document.querySelector("label[for='shop']")
		menu_link.focus();
		menu_checkbox.checked = false;
		document.removeEventListener("keydown",escapeMenu);
	}
}

function focusNavLi(li) {
	let selectable = li.querySelector("label");
	if(selectable == null) {
		selectable = li.querySelector("a");
	}
	selectable.focus();

}
function focusNext(el) {
	let nextSibling = el.closest("li").nextElementSibling;
	if(nextSibling) {
		focusNavLi(nextSibling);
	}
}
function focusPrev(el) {
	let prevSibling = el.closest("li").previousElementSibling;
	if(prevSibling) {
		focusNavLi(prevSibling);
	}
}



var local_escape_listeners = {};
var cache_escape_listeners = {};

		function selectAndFocus(menu,for_id, escapeLocalMenu) {
	        var menuOpen = menu.checked;
			var submenu_id = "#submenu-"+for_id;
			var $child_nav_items = document.querySelectorAll(submenu_id+" > li.main-links:not(.return) > label, "+submenu_id+" > li.main-links:not(.return) > a");
	        if(menuOpen) {
	            menu.checked = false;
	            if(for_id == "shop") {
	            	document.removeEventListener("keydown",escapeMenu);
	            } else {
	            	$child_nav_items.forEach(($child) => {
	            		$child.removeEventListener("keydown",escapeLocalMenu);
	            	});
	            	//document.removeEventListener("keydown",escapeLocalMenu);
	            	//delete local_escape_listeners[for_id];
	            }
	        } else {
	            menu.checked = true;
	            $child_nav_items[0].focus();
	            console.log("for_id",for_id);
	            if(for_id == "shop") {
	            	document.addEventListener("keydown",escapeMenu);
	            } else {
	            	//document.removeEventListener("keydown",escapeLocalMenu);
	            	//for(var key in local_escape_listeners) {
		            //	cache_escape_listeners[for_id] = escapeLocalMenu;
	            	//	document.removeEventListener("keydown", local_escape_listeners[key]);
	            	//	delete local_escape_listeners[key];
	            	//}
	            	//local_escape_listeners[for_id] = escapeLocalMenu;
	            	//document.addEventListener("keydown",escapeLocalMenu);
	            	$child_nav_items.forEach(($child) => {
	            		$child.addEventListener("keydown",escapeLocalMenu)

	            	});
	            }
	        }
		}
document.addEventListener("DOMContentLoaded",function(e) {

	document.querySelectorAll("#shop, .open_submenu").forEach(function(menu) {

		var menu_id = menu.getAttribute('id');

//		if(menu_id != "shop" && !window.matchMedia("(pointer: coarse)").matches) {
		/*
		if(menu_id != "shop" && !window.matchMedia("(max-width: 1024px)").matches) {
			menu.addEventListener("click",function(e) {
				console.log("e.stopImmediatePropagation()");
				e.preventDefault();
				//e.stopPropagation();
				console.log("disable radio click event on non-mobile browser");
				console.log("e.target",e.target);
				console.log("menu",menu);
			});
		}
		*/
		
		var menu_toggle_selector = "label[for='"+menu_id+"']";
		var menuToggles = document.querySelectorAll(menu_toggle_selector);

		function escapeLocalMenu(event) {
			
			if(event.keyCode == leftKeyCode) {
				console.log("escapeLocalMenu");
				event.preventDefault();
				console.log("menu",menu);
				menu.checked = false;
				document.removeEventListener("keydown",escapeLocalMenu);
				console.log("menuToggles",menuToggles);
				menuToggles[0].focus();
				for(var key in cache_escape_listeners) {
	            	document.addEventListener("keydown", cache_escape_listeners[key]);
	            	delete cache_escape_listeners[key];
	            }
			}
		}




		menuToggles.forEach(function(menuToggle) {
			menuToggle.addEventListener("keydown", function(event) {
				arrowtrigger = downKeyCode;
				var for_id = this.getAttribute('for');
				if(for_id != "shop") {
					arrowtrigger = rightKeyCode;
				}
			    if(event.keyCode == enterKeyCode || event.keyCode == spaceKeyCode || event.keyCode == arrowtrigger) {
			    	event.preventDefault();
			    	selectAndFocus(menu, for_id, escapeLocalMenu);
			    } else if (event.keyCode == downKeyCode) {
			    	event.preventDefault();
			    	focusNext(menuToggle);
			    } else if (event.keyCode == upKeyCode) {
			    	event.preventDefault();
			    	focusPrev(menuToggle);

			    }
			});
			menuToggle.addEventListener("click", function(e) {
				console.log("prevent label default on click");
				e.preventDefault();
				var for_id = this.getAttribute('for');
				var desktopLink = this.dataset.desktopLink;

				if(for_id != "shop" && !window.matchMedia("(max-width: 1024px)").matches) {
					console.log("disable radio click event on non-mobile browser");
					console.log("desktopLink",desktopLink);
					if(desktopLink && desktopLink != "#") {
						window.location.href = desktopLink;
					}
				} else {
					var for_input = document.querySelector("input[id='"+for_id+"']");
					console.log("for_input",for_input);
					if( for_input.checked ) {
						for_input.checked = false;
					} else {
						for_input.checked = true;
					}
				}
			})
		});

		menu.addEventListener('change', function(event) {
	        var menuOpen = menu.checked;
	        if(menuOpen) {
	        	if(menu_id == "shop") {
	        		/*
					gtag('event', 'conversion', {
					    'send_to': 'AW-798429914/mHxXCJXo3cgZENql3PwC',
					    'value': 1.0,
					    'currency': 'USD'
					});
					*/
	        	}
	   			menuToggles.forEach(function(menuToggle) {
	   				menuToggle.setAttribute("aria-expanded", true);
	   				menuToggle.setAttribute("aria-pressed", true);

	   			});
	        } else {
	   			menuToggles.forEach(function(menuToggle) {
	   				menuToggle.setAttribute("aria-expanded", false);
	   				menuToggle.setAttribute("aria-pressed", false);
	   			});
	        }
		});
		/*

		*/
	});

	let main_menu = document.querySelector("#shop");
	document.querySelector("a.menu-open-by-keyboard").addEventListener("click", (e) => {
		e.preventDefault();
		//main_menu.checked = true;
		selectAndFocus(main_menu, "shop", escapeMenu);
		//let $first_menu_choice = document.querySelector("#submenu-shop li:first-child");
		//focusNavLi($first_menu_choice);
	});
	document.querySelector("a.menu-close-by-keyboard").addEventListener("click", (e) => {
	  //e.preventDefault();
	  main_menu.checked = false;
	  collapseAllInMenu();
	});
	document.querySelectorAll(".main-links a").forEach(function(main_link) {
			main_link.addEventListener("keydown", function(event) {
				if (event.keyCode == downKeyCode) {
			    	event.preventDefault();
			    	focusNext(main_link);
			    } else if (event.keyCode == upKeyCode) {
			    	event.preventDefault();
			    	focusPrev(main_link);

			    }
			});
			main_link.addEventListener("click", (e) => {
  				//gtag('event', 'conversion', {'send_to': 'AW-798429914/ReQXCJD88cgZENql3PwC'});
			});
	});
	document.querySelectorAll("#mazer-variant-picker label").forEach(function(label) {
		label.addEventListener('keydown',function() {
			if(event.keyCode == enterKeyCode || event.keyCode == spaceKeyCode) {
				var for_id = this.getAttribute('for');
				var this_input = document.querySelector("#"+for_id);
				//this_input.checked = this_input.checked ? false : true;
				this_input.click();
			} else if(event.keyCode == leftKeyCode) {
				console.log("variant-picker");
				event.preventDefault();
		    	if(label.closest("modal-opener").previousElementSibling) {
		    		var prev_choice = label.closest("modal-opener").previousElementSibling.querySelector("label");
		    		prev_choice.focus();
		    	}
			} else if(event.keyCode == rightKeyCode) {
				event.preventDefault();
		    	if(label.closest("modal-opener").nextElementSibling) {
		    		var next_choice = label.closest("modal-opener").nextElementSibling.querySelector("label");
		    		next_choice.focus();
		    	}
			}
		});
	});
    registerColinAccordion();
});

function collapseAllInMenu() {
	document.querySelectorAll("#submenu-shop input").forEach(function(input) {
	  	input.checked = false;
	});
}


const acc_open_event = new Event("accordion_open");
const acc_close_event = new Event("accordion_close");

function toggleItem(e) {

            if(e.currentTarget.classList.contains('active') ) {
                e.currentTarget.classList.remove('active');
                e.currentTarget.dispatchEvent(acc_close_event);
            } else {
				if(e.currentTarget.classList.contains("close-others")) {

					let parentAccordion = e.currentTarget.closest("ul");
					if(parentAccordion) {
						(parentAccordion.querySelectorAll("ul > li > .key") || [] ).forEach(function($el) {
							$el.classList.remove('active');
						});
					} else {
						console.log("no parentAccordion found");
					}

				}
                e.currentTarget.classList.add('active');
                e.currentTarget.dispatchEvent(acc_open_event);

            }
}

function registerColinAccordion() {
	(document.querySelectorAll(".colin-accordion > ul > li > .key") || []).forEach(function($el) {
		$el.removeEventListener("click",toggleItem);
        $el.addEventListener('click',toggleItem);
    });
}